var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZambia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 512C397.385 512 512 397.385 512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.174 256H256V512C285.924 512 314.641 506.849 341.333 497.414L356.174 256Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.666 446.793C479.034 399.919 512 331.813 512 256H411.826L426.666 446.793Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.333 256V497.414C373.13 486.173 402.044 468.834 426.667 446.794V256H341.333Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.043 166.957H406.26C406.26 154.663 396.293 144.696 383.999 144.696C371.705 144.696 361.738 154.663 361.738 166.957H294.955C294.955 179.252 305.664 189.218 317.957 189.218H317.216C317.216 201.513 327.181 211.479 339.477 211.479C339.477 223.774 349.442 233.74 361.738 233.74H406.26C418.554 233.74 428.521 223.774 428.521 211.479C440.815 211.479 450.782 201.513 450.782 189.218H450.041C462.335 189.217 473.043 179.251 473.043 166.957V166.957Z",
    fill: "#FF9811"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7333"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZambia);
export default __webpack_public_path__ + "static/media/zambia.7a4048382f200d73fb964ad00c7dc921.svg";
export { ForwardRef as ReactComponent };